import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import RadioButtonQuest from '../../../../UI/RadioButtonQuest';
import GtmDataLayer from "../../../../../Utility/GtmDataLayer";

const ClosedYear = ({ clsName, onSelectAnswer, unQualifiedAnswer }) => {

    const [claimModal, setshowClaimModal] = useState(false);
    const handleCloseclaimModal = () => setshowClaimModal(false);

    const optionHandle = async (e) => {
        if (e.target.value === "377") {
            onSelectAnswer(e);
            // setshowClaimModal(true);
        } else if (e.target.value === "378") {
            onSelectAnswer(e);
        }
    }

    return (
        <>
            <div className={`qsSlider slidea1 ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                Was your account closed over 6 years ago?
                </h2>
                <div className="btn-option optinal-items singleqs slide-up-now">
                    <div className=" option_but mb-3">
                        <RadioButtonQuest
                            key="cy1"
                            className="radio"
                            labelName="Yes"
                            onClick={optionHandle}
                            value="377"
                            name="closedYear"
                            id="cy1"
                            dataQuestId={122}
                            dataAnsId={377}
                            dataAnsLabel="Yes"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="cy2"
                            className="radio"
                            labelName="No"
                            onClick={optionHandle}
                            value="378"
                            name="closedYear"
                            id="cy2"
                            dataQuestId={122}
                            dataAnsId={378}
                            dataAnsLabel="No"
                        />
                    </div>
                </div>
            </div>



            {/* <Modal
                show={claimModal}
                onHide={handleCloseclaimModal}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="creditpopup">
                    <div className="pb-3">
                        <div className="row align-items-center">
                            <div className="col-lg-12 col-md-12 col-sm-3 col-2 text-center">
                                <div className="mb-lg-3 mb-md-3 mb-sm-0 mb-0">
                                    <img
                                        className="alertimg"
                                        src="../../assets/QuestionaireUFC_DC_V1/img/alert.png"
                                        height="50"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-9 col-10">
                                <h6 className="mb-0 text-lg-center text-md-center text-sm-start text-start px-lg-3 px-md-3 px-sm-0 px-0">
                                    Sorry we cannot help, as you are likely to be too late to make a claim.
                                </h6>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    );
};

export default ClosedYear;
